import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { logError } from "../common/utils/logger";

export const validateBankAccount = async (payload) => {
  try {

    const response = await api.post(
      API_ENDPOINTS.BANK_ACCOUNT_VALIDATE,
      payload
    );

    return response?.data ?? null;

  } catch (error) {
    logError("Bank account validation failed", error);
    throw error;
  }
};